module.exports = {
    model: {
        // potential fieldConfig values set within cms_templateAtoms.config
        // config: {
        //     fields: {
        //          sendConfirmation: {
        //             disabled: false
        //          }
        //     }
        //     sendConfirmationOnChange: true, // should this field be marked as sendConfirmation if the value changes?
        //     separatedFieldCodes: {
        //         email: 'email',
        //         emailConfirmed: 'emailConfirmed',
        //         emailConfirmedAt: 'emailConfirmedAt',
        //         emailConfirmationSentAt: 'emailConfirmationSentAt',
        //     }
        // }
        dataJSON: {},
        sendEmailConfirmation: false
    },

    events: {
        sendConfirmation: {
            type: 'click',
            selector: 'button',
            action: function(event){
                event.stopImmediatePropagation();
                const self = event.data.component;
                const $target = $(event.target).closest('button');
                const fieldType = $target.data('fieldType')

                if(fieldType === 'sendConfirmation'){
                    self.toggleSendConfirmation()
                }
            }
        },

        onChange: {
            type: 'change',
            action: function(event){
                event.preventDefault();
                event.stopImmediatePropagation();

                const self = event.data.component;
                self.updateValue(self.$.find('input[type="text"]').val(), true)
            }
        },
    },

    methods: {
        toggleSendConfirmation(forceValue){
            const fieldConfig = this.model.config || {}
            const fieldsConfig = fieldConfig.fields || {}
            if((fieldsConfig.sendConfirmation || {}).disabled) return;

            if(forceValue === undefined){
                this.model.sendEmailConfirmation = !this.model.sendEmailConfirmation
            } else {
                this.model.sendEmailConfirmation = forceValue
            }
            this.triggerClosest('onChildChanged', {
                fieldCode: 'emailMeta',
                value: {
                    sendEmailConfirmation: this.model.sendEmailConfirmation
                }
            })
            this.refresh(false)
        },

        updateValue: function(value, tellParents){
            let valueChanged = false;
            if(value !== undefined){
                if(!value) value = null;
                valueChanged = this.model.dataJSON.email !== value;
                this.model.dataJSON.email = value;
            }

            if(valueChanged){
                this.model.dataJSON.emailConfirmed = false
                this.model.dataJSON.emailConfirmedAt = null
                this.model.dataJSON.emailConfirmationSentAt = null

                if(tellParents && this.model.dataJSON.email !== undefined){
                    this.triggerClosest('onChildChanged', {
                        fieldCode: this.model.fieldCode,
                        value: this.model.dataJSON
                    });
                }

                if((this.model.config || {}).sendConfirmationOnChange !== false){
                    this.toggleSendConfirmation(!!value)
                }
            }
        }
    },
}